"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postAcademyAdminMembers = exports.useClassAcademyMembers = exports.getClassAcademyMembers = exports.useAcademyMembers = exports.getAcademyMembers = exports.leaveAcademy = exports.enrollAcademy = exports.postAcademyAdmin = exports.useAcademiesList = exports.getAcademiesList = void 0;
const account_1 = require("../../features/base/account");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
const getAcademiesList = async (props) => {
    const queryString = (0, functions_1.objectToQueryString)(props);
    const url = `/api/mimac/v1/academies?${queryString}`;
    const options = {
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.getAcademiesList = getAcademiesList;
const useAcademiesList = (data) => {
    return (0, functions_1.useCustomQuery)([data], () => (0, exports.getAcademiesList)(data));
};
exports.useAcademiesList = useAcademiesList;
const postAcademyAdmin = async (data) => {
    const { tenant_id, ...body } = data;
    const url = `/api/mimac/v1/admin/academy`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
            'X-Tenant-ID': tenant_id,
        },
        body: JSON.stringify(body),
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.postAcademyAdmin = postAcademyAdmin;
const enrollAcademy = async (data) => {
    const url = `/api/mimac/v1/academies/enroll`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.enrollAcademy = enrollAcademy;
const leaveAcademy = async (data) => {
    const url = `/api/mimac/v1/academies/leave`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.leaveAcademy = leaveAcademy;
const getAcademyMembers = async (academyId, props) => {
    const queryString = (0, functions_1.objectToQueryString)(props);
    const url = `/api/mimac/v1/academies/${academyId}/members?${queryString}`;
    const options = {
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.getAcademyMembers = getAcademyMembers;
const useAcademyMembers = (academyId, data) => {
    return (0, functions_1.useCustomQuery)([academyId, data], () => (0, exports.getAcademyMembers)(academyId, data));
};
exports.useAcademyMembers = useAcademyMembers;
const getClassAcademyMembers = async (classId, props) => {
    const queryString = (0, functions_1.objectToQueryString)(props);
    const url = `/api/mimac/v1/admin/class/${classId}/academy-members?${queryString}`;
    const options = {
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.getClassAcademyMembers = getClassAcademyMembers;
const useClassAcademyMembers = (classId, data) => {
    return (0, functions_1.useCustomQuery)([classId, data], () => (0, exports.getClassAcademyMembers)(classId, data));
};
exports.useClassAcademyMembers = useClassAcademyMembers;
const postAcademyAdminMembers = async (data) => {
    const url = `/api/mimac/v1/admin/academy/members`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.postAcademyAdminMembers = postAcademyAdminMembers;
